import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import validator from 'utils/validator';
import { useRouter } from 'next/router';
import TreeEditorPreview from './preview';
import TreeEditorSource from './source';
import EditorLayout from '../new/components/layout';
import { Button, Typography } from '../components/base';

const TreeEditor = props => {
  const router = useRouter();

  const treeId = useMemo(() => {
    if (Array.isArray(props.query.params)) {
      if (props.query.params.length >= 1) {
        const [id] = props.query.params;
        if (validator.isNumeric(id)) {
          return parseInt(id, 10);
        }
      }
    }
    return undefined;
  }, [props.query]);

  if (treeId) {
    const handleOnSuccess = () => {
      router.push('/user/trees');
    };

    return <TreeEditorPreview treeId={treeId} onSuccess={handleOnSuccess} />;
  }

  if (props.product.options?.length > 0) {
    return <TreeEditorSource {...props} />;
  }

  const handleOnClick = e => {
    e.preventDefault();

    router.push('/');
  };

  return (
    <EditorLayout
      product={props.product}
      actionButton={
        <Button variant="primary" onClick={handleOnClick}>
          Leave
        </Button>
      }
    >
      <div className="text-center my-3">
        <Typography.Heading size={1} mb={3}>
          Oh no! We’re sorry, something has gone wrong.
        </Typography.Heading>
      </div>
    </EditorLayout>
  );
};

TreeEditor.propTypes = {
  product: PropTypes.object,
  query: PropTypes.object,
  onSuccess: PropTypes.func,
  children: PropTypes.node,
};

export default TreeEditor;
